/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1037
 */

module.exports = {
  content: "Align_content__23Jaw",
  alignRadio: "Align_alignRadio__3CHfv"
}
